module.exports = __webpack_public_path__ + "img/AlamovsCobra.508bcb57.png";